/* eslint no-param-reassign: "off", no-console: "off" */
import Vuex from 'vuex';
import { orderBy } from 'lodash';

const appsettingsStore = {
  state: {
    theme: 'kymeta',
    menuCollapsed: false,
    detailFullWidth: false,
    detailedErrors: false,
    defaultStartRoute: 'home',
    userListSettings: [],
    userGraphs: [],
    recentRemotes: [],
    recentTerminals: [],
    recentDevices: []
  },
  mutations: {
    fetchSettings(state, payload) {
      state.menuCollapsed = payload.menuCollapsed || false;
      // eslint-disable-next-line no-void
      state.detailFullWidth = payload.detailFullWidth != void 0 ? payload.detailFullWidth : true;
      state.theme = payload.theme || 'kymeta';
      state.defaultStartRoute = payload.defaultStartRoute || 'home';
      state.userListSettings = payload.listSettings || [];
      state.userGraphs = payload.userGraphs || [];
      state.detailedErrors = payload.detailedErrors || false;
    },
    changeTheme(state, payload) {
      state.theme = payload;
    },
    toggleMenuCollapse(state) {
      state.menuCollapsed = !state.menuCollapsed;
    },
    setExpandDetailPane(state, payload) {
      state.detailFullWidth = payload;
    },
    setDetailedErrors(state, payload) {
      state.detailedErrors = payload;
    },
    setDefaultStartRoute(state, payload) {
      state.defaultStartRoute = payload;
    },
    fetchRecentRemotes(state, payload) {
      state.recentRemotes = payload || [];
    },
    fetchRecentDevices(state, payload) {
      state.recentDevices = payload || [];
    },
    fetchRecentTerminals(state, payload) {
      state.recentTerminals = payload || [];
    },
    removeUserGraph(state, payload) {
      state.userGraphs = state.userGraphs.filter(g => g.id != payload);
    }
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    async updateSetting({ dispatch }, payload) {
      // eslint-disable-next-line no-undef
      await $userStore.setItem(payload.key, payload.value);
      await dispatch('fetchSettings');
    },
    fetchSettings({ commit }) {
      const settings = {};
      // eslint-disable-next-line no-undef, no-unused-vars
      return $userStore.iterate((value, key, iterationNumber) => { 
        settings[key] = value;
      })
        .then(() => {
          commit('fetchSettings', settings);
          return true;
        });
    },
    async fetchRecentEntities({ commit }) {
      // eslint-disable-next-line no-undef
      const r = await $userStore.getItem('recentRemotes');
      // eslint-disable-next-line no-undef
      const d = await $userStore.getItem('recentDevices');
      // eslint-disable-next-line no-undef
      const t = await $userStore.getItem('recentTerminals');

      commit('fetchRecentRemotes', r);
      commit('fetchRecentDevices', d);
      commit('fetchRecentTerminals', t);
    },
    async setRecentTerminal({ }, payload) {
      try { 
        const entity = { ts: Date.now(), id: payload.id, name: payload.name }
        // eslint-disable-next-line no-undef, no-unused-vars
        let currentRecents = await $userStore.getItem('recentTerminals');
        if (!currentRecents) currentRecents = [];
        const existingIndex = currentRecents.findIndex(s => s.id == payload.id);
        if (existingIndex == -1) {
          if (currentRecents.length >= 5) {
            currentRecents = orderBy(currentRecents, ['ts'], ['desc']);
            currentRecents.pop();
          }
          currentRecents.unshift(entity);
        } else {
          currentRecents[existingIndex] = entity;
        }
        // eslint-disable-next-line no-undef, no-unused-vars
        await $userStore.setItem('recentTerminals', currentRecents);
      } catch (ex) { console.error(ex); }
    }
  },
  getters: {

  }
}
export default appsettingsStore;
export const useAppSettingsStore = () => new Vuex.Store(appsettingsStore);
